// extracted by mini-css-extract-plugin
export default {"codeSnippet":"CodeSnippet_codeSnippet__K-Xgl","codeSnippetHeader":"CodeSnippet_codeSnippetHeader__TNHT+"};